import { axiosClient } from '../../../library/Service/axiosClient';

const BASE = () => `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/vibrancy`;

export interface WatchlistAlumni {
    studentId: string;
    name: string;
    layer: string;         // 'Signal' | 'Strategic'
    passOutYear?: number;
    reason: string;
    actionCount: number;   // email activities + outreach interactions; rows are ranked by this
}

export interface AdvancementAlumni {
    studentId: string;
    name: string;
    passOutYear?: number;
    fromStage: string;
    toStage: string;
    actionCount: number;   // email activities + outreach interactions; rows are ranked by this
}

export interface WatchlistData {
    signals: {
        total: number;
        prevTotal: number;
        signalLayer: number;
        strategicLayer: number;
        newSignals: number;
        alumni: WatchlistAlumni[];
    };
    advancements: {
        total: number;
        prevTotal: number;
        stages: { label: string; count: number }[];
        qualifiedContributing: number;
        alumni: AdvancementAlumni[];
    };
}

export const VibrancyWatchlistService = {
    /**
     * GET /vibrancy/watchlist?institute_id=X&period=monthly
     * Returns signals + advancements for the given institute + period.
     */
    getWatchlistData: (instituteId: string | number, period: string) =>
        axiosClient().get<{ success: boolean; data: WatchlistData }>(`${BASE()}/watchlist`, {
            params: { institute_id: instituteId, period },
        }),
};
